import Billing from "../../userProfile/billing";

const BillingOverview = () => {
  return (
    <div>
      <Billing />
    </div>
  );
};

export default BillingOverview;
